import { forwardRef } from '@angular/core';

import { AbstractValueControlBase } from '../types/abstract-value-control-base';

/**
 * å¨å­ç»ä»¶ä¸­ä½¿ç¨ç¶ç»ä»¶ provide AbstractValueControlBaseæ¥è·åå½åå®ä¾
 *
 * è¿æ ·å°±å¯ä»¥å¨æä»¤/ç»ä»¶ä¸­ï¼ä½¿ç¨ç¶ç»ä»¶ç±»åAbstractValueControlBaseæ¥è·åå½åå®ä¾
 */
export function provideValueControlParent(component: any) {
  return provideParent(component, AbstractValueControlBase);
}

// Helper method to provide the current component instance in the name of a `parentType`.
// The `parentType` defaults to `Parent` when omitting the second parameter.
export function provideParent(component: any, parentType: any) {
  return { provide: parentType, useExisting: forwardRef(() => component) };
}
